import { render, staticRenderFns } from "./PersonForm.vue?vue&type=template&id=21c7e59b&scoped=true"
import script from "./PersonForm.vue?vue&type=script&lang=js"
export * from "./PersonForm.vue?vue&type=script&lang=js"
import style0 from "./PersonForm.vue?vue&type=style&index=0&id=21c7e59b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c7e59b",
  null
  
)

export default component.exports